// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { RTK_PROMISE_TRACKER_ID } from '@shared/data-access/utils/constants';
import { appStore } from '@client-app/store';
import { advisoryApi } from '@shared/data-access/api/brokerage/advisory-api.v2';
import { redirect, type LoaderFunction } from 'react-router';
import { trackPromise } from 'react-promise-tracker';
import { isTest } from '@shared/environment';
import {
  selectAccountCurrency,
  selectToken,
} from '@shared/data-access/slices/user';

/* istanbul ignore next */
export const dashboardLoader: LoaderFunction = async ({ request }) =>
  trackPromise(
    (async () => {
      await new Promise<void>(resolve => {
        if (isTest) {
          resolve();
          return;
        }

        const unsubscribe = appStore.subscribe(() => {
          const state = appStore.getState();
          if (state._persist?.rehydrated) {
            unsubscribe();
            resolve();
          }
        });

        const currentState = appStore.getState();

        if (currentState._persist?.rehydrated) {
          resolve();
        }
      });

      const state = appStore.getState();

      if (!selectToken(state)) return { ok: true };

      const currency = selectAccountCurrency(state);

      const advisoryInstitutionsResponse = await appStore.dispatch(
        advisoryApi.endpoints.getAdvisoryInstitutions.initiate({ currency }),
      );

      if (
        advisoryInstitutionsResponse.data &&
        advisoryInstitutionsResponse.status === 'fulfilled'
      ) {
        if (advisoryInstitutionsResponse.data.length === 0) {
          return redirect('/banks');
        }
      }

      if (request.url.includes('aggregation')) {
        return { ok: true };
      }

      return redirect('/aggregation');
    })(),
    RTK_PROMISE_TRACKER_ID,
  );
